import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-1 flex items-center px-4 pt-20 w-full container max-w-xl mx-auto" }
const _hoisted_2 = { class: "space-y-8" }
const _hoisted_3 = { class: "space-y-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl font-bold" }, "Sign In", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConnectCta = _resolveComponent("ConnectCta")!
  const _component_ConnectProviderList = _resolveComponent("ConnectProviderList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_ConnectCta)
      ]),
      _createElementVNode("article", null, [
        _createElementVNode("div", null, [
          _createVNode(_component_ConnectProviderList, {
            providers: _ctx.wallet.providers,
            onConnect: _ctx.login
          }, null, 8, ["providers", "onConnect"])
        ])
      ])
    ])
  ]))
}